import toml from '@iarna/toml'

/**
 * 將 JS Object 轉為 TOML
 * @param {string} input
 * @returns {Promise<string>} output
 */
export default async function convertJSObjectToTOML(input) {
  const object = eval(`(${input})`)
  return toml.stringify(object)
}
